import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { AdminsListState, ADMINS_LIST_SLICE_NAME } from './models';

export const adminsSelector = (state: RootState): AdminsListState => state[ADMINS_LIST_SLICE_NAME];

export const selectAdminsIsLoading = createSelector(adminsSelector, (state: AdminsListState) => state.isLoading);

export const selectAdminsList = createSelector(adminsSelector, (state: AdminsListState) => state.adminsList);

export const selectAdminFilters = createSelector(adminsSelector, (state: AdminsListState) => state.adminFilters);
